import { useWindowSize } from "react-use";

const useWindowWidth = () => {
  const { width } = useWindowSize();
  return width;
};

export default useWindowWidth;
